import {
    ADD_TOKEN,
    ADD_ID,
} from '../constants/AppConstants'


export default function AppReducer(state = {}, action) {
    switch (action.type) {
        case ADD_TOKEN:
            return {
                ...state,
                ...action.payload
            };
        case ADD_ID:
            return {
                ...state,
                ...action.payload
            };
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/AppReducer.js